import React from 'react';
import {connect} from 'react-redux';
import envcompany from 'envcompany';
import {
    Switch,
    Redirect,
    Route
} from 'react-router-dom';
import BaseLayer from 'components/BaseLayer';
import WrapAuth from './WrapAuth';
import InitialPage from './InitialPage';
import App from './App';
import Appkey from 'pages/Appkey';
import AppkeyView from 'pages/Appkey/view';
import BundleList from 'pages/BundleList';
import BundleNew from 'pages/BundleNew';
import BundleView from 'pages/BundleView';
import BundleEdit from 'pages/BundleEdit';

import Consumption from 'pages/Consumption';
import KTPConsumption from 'pages/KTPConsumption';
import ChangePassword from 'pages/ChangePassword';
import SDKDownload from 'pages/SDKDownload';
import SDKLivenessList from 'pages/SDKLiveness/SDKLivenessList';
import SDKLivenessCreate from 'pages/SDKLiveness/SDKLivenessCreate';
import SDKLivenessEdit from 'pages/SDKLiveness/SDKLivenessEdit';

import SDKVerifyList from 'pages/Verify/SDKVerifyList';
import VerifyCreate from 'pages/Verify/VerifyCreate';
import VerifyEdit from 'pages/Verify/VerifyEdit';
import Encryption from 'pages/Encryption';
import LiteScenesList from 'pages/LiteScenes/LiteScenesList';
import LiteCreate from 'pages/LiteScenes/LiteCreate';
import LiteEdit from 'pages/LiteScenes/LiteEdit';

//导航菜单
const menus = [
    { name: 'App configuration', key: 'app', icon:'app', isSubMenu:true,
        sub:[
            { name: 'Appkey', url: '/pages/app/appkey' },
            { name: 'Mobile Client', url: '/pages/app/bundle' },
            { name: 'SDK Config Scenes', url: '/pages/sdk-scenes' },
            { name: 'Verify Config Scenes', url: '/pages/verify-scenes' },
            { name: 'H5 Config Scenes', url: '/pages/lite-scenes' },
            { name: 'Encryption', url: '/pages/encryption' },
        ]
    },
    { name: 'Report', key:'reports',icon:'consumption',isSubMenu:true,
        sub:[
            { name: 'Face Verification', url: '/pages/consumption'},
            { name: 'Indonesia ID card', url: '/pages/ktp-consumption'}
        ]
    },
    { name: 'SDK Download',key:'sdk_download',icon:'download',url:'/pages/sdk-download'}
];

// 迁移v2-2版本，双边菜单一致，但已迁移客户登录faceid的要特殊处理
const migratedMenu = menus.filter(i => i.key !== 'app');

class BaseRouter extends React.Component {

    constructor(props) {
        super(props);
        this.path = '';
        this.ComponentCatch = [];
    }

    // componentDidCatch(){
    //     debugger;
    // }

    shouldComponentUpdate(nextProps,nextState){
        if(nextProps === this.props && nextState === this.state){
            return false;
        }
        return true;
    }

    componentWillReceiveProps(nextProps) {
        const { location, history: { action } } = nextProps;
        if (location !== this.props.location && action === 'PUSH') {
            window.scrollTo(0, 0);
        }
    }

    render() {
        let defaultRoute = '/pages/app/appkey';
        // transfer_status  0：默认值，标识未迁移，1：旷视客户迁移到原力，2：原力新注册用户。
        const transfer_status = this.props.account.transfer_status;
        let showMenus = menus;
        if (envcompany.baseName === 'FaceID') {
            if (transfer_status === 1) {
                defaultRoute = '/pages/consumption';
                showMenus = migratedMenu;
            }
        }

        const PageRoute = ({ component: Component, ...rest }) => {
            this.path = rest.path;
            const props = this.props;
            const path =  this.path;
            let WrapAuthComponent;
            if (this.ComponentCatch[path]){
                WrapAuthComponent = this.ComponentCatch[path];
            }else{
                WrapAuthComponent = WrapAuth(Component, props.account, path);
                this.ComponentCatch[path] = WrapAuthComponent;
            }

            return (
                <Route {...rest} render={()=> {
                    return <InitialPage {...props} path={this.path}><WrapAuthComponent/></InitialPage>;
                }} />
            );
        };

        return (
            <BaseLayer menus={showMenus}>
                <Switch>
                    <PageRoute exact path='/pages/app' component={App} />
                    <PageRoute exact path='/pages/app/appkey' component={Appkey} />
                    <PageRoute exact path='/pages/app/appkey/view/:id' component={AppkeyView} />
                    <PageRoute exact path='/pages/app/bundle' component={BundleList} />
                    <PageRoute exact path='/pages/app/bundle/new' component={BundleNew} />
                    <PageRoute exact path='/pages/app/bundle/:id' component={BundleView} />
                    <PageRoute exact path='/pages/app/bundle/:id/edit' component={BundleEdit} />
                    <PageRoute exact path='/pages/password/update' component={ChangePassword}/>
                    <PageRoute exact strict path='/pages/consumption' component={Consumption} />

                    <PageRoute exact strict path='/pages/ktp-consumption' component={KTPConsumption} />
                    <PageRoute exact strict path='/pages/sdk-download' component={SDKDownload} />
                    <PageRoute exact strict path='/pages/sdk-scenes' component={SDKLivenessList} />
                    <PageRoute exact strict path='/pages/sdk-scenes/create' component={SDKLivenessCreate} />
                    <PageRoute exact strict path='/pages/sdk-scenes/edit/:id' component={SDKLivenessEdit} />
                    <PageRoute exact strict path='/pages/verify-scenes' component={SDKVerifyList} />
                    <PageRoute exact strict path='/pages/verify-scenes/create' component={VerifyCreate} />
                    <PageRoute exact strict path='/pages/verify-scenes/edit/:id' component={VerifyEdit} />
                    <PageRoute exact strict path='/pages/lite-scenes' component={LiteScenesList} />
                    <PageRoute exact strict path='/pages/lite-scenes/create' component={LiteCreate} />
                    <PageRoute exact strict path='/pages/lite-scenes/edit/:id' component={LiteEdit} />
                    <PageRoute exact strict path='/pages/encryption' component={Encryption} />
                    <Redirect from='/pages' to={defaultRoute} />
                </Switch>
            </BaseLayer>

        );
    }

}
function select(state){
    return {
        account : state.account.info
    };
}

export default connect(select)(BaseRouter);



// WEBPACK FOOTER //
// ./src/pages/BaseRouter.js